module.exports = __webpack_public_path__ + "img/box6Ft.40a5bd17.png";